import { ApolloQueryResult } from 'apollo-client/core/types'
import { useQuery } from 'react-apollo'
import { PW_GET_DISPLAY_SUBSCRIPTION_STATUS } from 'src/apollo/api'

import useWorkspaceId from 'src/hooks/useWorkspaceId';

export enum DisplaySubscriptionStatusEnums {
  INACTIVE = 'INACTIVE',
  STANDARD = 'STANDARD',
  PRO = 'PRO'
}

export interface IGetAccountDisplaySubscriptionStatus {
  status: DisplaySubscriptionStatusEnums
  loading: boolean
  refetch?: (variables?: any) => Promise<ApolloQueryResult<any>>
}

export const getCurrentWorkspaceDisplaySubscriptionStatus = (workspaceId?: string): IGetAccountDisplaySubscriptionStatus => {
  const exiistingWorkspaceId = useWorkspaceId();
  const workspaceIdForRequest = workspaceId ? workspaceId : exiistingWorkspaceId;

  const { data, loading, refetch } = useQuery(PW_GET_DISPLAY_SUBSCRIPTION_STATUS, {
    skip: !workspaceIdForRequest,
    fetchPolicy: 'cache-and-network',
    variables: {
      idsDTO: { workspaceId: workspaceIdForRequest }
    }
  })

  const status = data?.getDisplaySubscriptionStatus as DisplaySubscriptionStatusEnums

  return {
    status,
    loading,
    refetch,
  }
}
